import { create } from "zustand";

interface LiveaboardModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useLiveaboardModal = create<LiveaboardModalStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useLiveaboardModal;
